module.exports = "/static/assets/8b29b690f3376eeef1980f90e0ebe006.png";